import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NursingNote } from 'src/app/case-manager/models/nursingNote';
import { CaseManagementService } from 'src/app/core/services/v2/case-management.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-addnote-dialog',
  templateUrl: './addnote-dialog.component.html',
  styleUrls: ['./addnote-dialog.component.scss']
})
export class AddnoteDialogComponent {

  action:string;
  local_data:any;
  casenursingNote:NursingNote;

  constructor(
    public dialogRef: MatDialogRef<AddnoteDialogComponent>,
    private loaderService: WindowLoaderService,
    private caseManagementService:CaseManagementService,
    //@Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.local_data = {...data};
    this.action = this.local_data.action;
    //if(this.local_data.caseNursingNote)
    this.casenursingNote=this.local_data.caseNursingNote    
    // else{
    //   this.casenursingNote=new NursingNote();
    // }
  }

  doAction(){
    if(this.action=='Add'){
      this.loaderService.show();
this.caseManagementService.addNursingNote(this.casenursingNote).subscribe(
  (res) => {  
    this.loaderService.hide();
    this.dialogRef.close({event:this.action,caseNursingNote:res.result});
  },
  (error) => {
    console.error(error);
    this.loaderService.hide();
    this.dialogRef.close({event:this.action,ccaseNursingNote:null});
  },
  () => {
    this.loaderService.hide();
    this.dialogRef.close({event:this.action,ccaseNursingNote:null});
  }
);
    }else{
      this.loaderService.show();
      this.caseManagementService.editNursingNote(this.casenursingNote).subscribe(
        (res) => {  
          this.loaderService.hide();
          this.dialogRef.close({event:this.action,caseNursingNote:res.result});
        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
          this.dialogRef.close({event:this.action,ccaseNursingNote:null});
        },
        () => {
          this.loaderService.hide();
          this.dialogRef.close({event:this.action,ccaseNursingNote:null});
        }
      );
    }
   
  }

  closeDialog(){
    this.dialogRef.close({event:'Cancel'});
  }
}
